<template>
    <div>
        <ui-modal ref="newDeal" title="New Deal" @hide="reset" dismiss-on="close-button esc">
            <div class="container-fluid" :style="'padding: 0; margin-top: 1rem;' + (drop ? 'height: 10rem;' : '')">
                <div class="row">
                    <div class="col-12">
                        <ui-vehicle-picker
                            label="Select the vehicle you would like to sell..."
                            v-model="instance"
                            :status="[VehicleLifeCycleStatuses.IN_STOCK]"
                            @dropdown-open="drop = true;"
                            @dropdown-close="drop = false"
                        ></ui-vehicle-picker>
                    </div>
                </div>
            </div>

            <div slot="footer" style="width: 100%; text-align: right;">
                <ui-progress-circular v-show="isLoading" style="float:left;"></ui-progress-circular>
                <button :disabled="isLoading||!this.instance" class="btn btn-primary" @click="save">Next</button>
            </div>
        </ui-modal>
    </div>
</template>

<script>
    import UiVehiclePicker from '../../components/forms/controls/KeenVehiclePicker'
    import { VehicleLifeCycleStatuses } from '../../classes/Api/Vehicle'

    export default {
        components: {
            UiVehiclePicker
        },
        data() {
            return {
                instance: {},
                isLoading: false,
                drop: false,
                VehicleLifeCycleStatuses,
            }
        },
        methods: {
            reset() {
                this.isLoading = false;
                this.instance = {};
            },
            open() {
                this.reset();
                this.$refs['newDeal'].open();
            },
            save() {
                this.isLoading = true;
                this.$root.navigateTo('deals/create?ref=' + this.instance.id)
            }
        }
    }
</script>